import { h } from 'preact'
import { tagParser } from '../../js/modules/utilities.js'

export const ReassuranceService = ({ items, cacheKey }) => {
   return (
      <div class="container-fluid">
         <div id="zone_reassurance_service" class="row mb-2" data-testid="bande-reassurance-service" data-cache-key={cacheKey}>
            {items.map((reassurance, index) => {
               const { title, image, alt, description, CTA, analytics } = reassurance
               return (
                  <div class="col-12">
                     <div
                        class={`lien-composite card ob1-push ob1-push-zigzag ${
                           index % 2 !== 0 ? 'ob1-push-zigzag-even ob1-push-shadow-right ob1-push-md-shadow-left' : 'ob1-push-zigzag-odd ob1-push-shadow-right'
                        }`}
                        data-testid={`reassurance-service${index}`}
                        data-pdb-zid={analytics.pdbZid}
                        data-pdb-sc={analytics.pdbSc}
                        data-pdb-idc={analytics.pdbIdc}
                        data-pdb-vi={analytics.pdbVi}
                        data-oevent-category={analytics.oeventCategory}
                        data-oevent-action={analytics.oeventAction}
                        data-oevent-label={analytics.oeventLabel}
                        data-oevent-other={analytics.oeventOther}
                     >
                        <div class="card-item card-image">
                           <div class="card-header">
                              <picture>
                                 <source srcset={`${image}?format=425x283&saveas=webp`} media="(max-width: 959px)" />
                                 <source srcset={`${image}?format=523x349&saveas=webp`} media="(max-width: 1199px)" />
                                 <img loading="lazy" src={`${image}?format=630x420&saveas=webp`} class=" card-img-top" alt={alt} />
                              </picture>
                           </div>
                        </div>
                        <div class="card-item card-content">
                           <div class="card-body">
                              <h2 class="card-title" dangerouslySetInnerHTML={{ __html: tagParser(title) }}></h2>
                              <p class="card-text" dangerouslySetInnerHTML={{ __html: tagParser(description) }}></p>
                              <p class="py-0 card-btn">
                                 <a
                                    href={CTA.URL}
                                    class="btn btn-secondary"
                                    aria-label={`${CTA.label} : ${CTA.ariaLabel}`}
                                    target={CTA.target}
                                    dangerouslySetInnerHTML={{ __html: tagParser(CTA.label) }}
                                 ></a>
                              </p>
                           </div>
                        </div>
                     </div>
                  </div>
               )
            })}
         </div>
      </div>
   )
}
